<div class="card">
  <div class="card-body" style="padding:10px">
    <div class="row">
      <div class="col-md-12 pt-0">
        <h5 class="border-bottom pb-1 mb-1">{{'componentPages.Meeting Status Reports' | translate}}</h5>
      </div>
      <div class="col-lg-12">
        <spinner [id]="'editexcel'" [show]='activeSpinner'></spinner>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-12 col-xl col-md-6">
            <div class="form-group">
              <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="editweightfilter['ay']" class="form-control custom-selectbox w-100">
                <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6">
            <div class="form-group">
              <label>{{'dataSubs.Time Period' | translate}}<span class="required-field">*</span></label>
              <select [(ngModel)]="timePeriod" class="form-control custom-selectbox w-100"
                (change)="setTimePeriod(timePeriod)">
                <option value="undefined" [disabled]="true">{{'dataSubs.Select Time Period' | translate}}</option>
                <option *ngFor="let item of timePeriodList" [value]="item.key">{{'dataSubs.' +item.value | translate}}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6" *ngIf="dynamicTimePeriod == 'monthly'">
            <div class="form-group">
              <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
              <select style="width: 200px; margin-left: 20px;" [(ngModel)]="editweightfilter['month']"
                class="form-control custom-selectbox">
                <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
                <option *ngFor="let month of monthsList" [value]="month.key">
                  {{'monthmaps.' + month['value'] | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6" *ngIf="dynamicTimePeriod == 'quarterly'">
            <div class="form-group">
              <label>{{'aggregatedpage.quat' | translate}}<span class="required-field">*</span></label>
              <select [(ngModel)]="selectedQuat" (change)="changeQuatData(selectedQuat)"
                class="form-control custom-selectbox w-100">
                <option value="undefined" [disabled]="true">{{'aggregatedpage.Select Quarterly' | translate}}</option>
                <option *ngFor="let item of quaterlyList |keyvalue" value="{{item['key']}}">{{'aggregatedpage.' +item['value'] | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6" *ngIf="dynamicTimePeriod == 'halfyearly'">
            <div class="form-group">
              <label>{{'aggregatedpage.half' | translate}}<span class="required-field">*</span></label>
              <select [(ngModel)]="selectedhalfyear" (change)="changeHalfyData(selectedhalfyear)"
                class="form-control custom-selectbox w-100">
                <option value="undefined" [disabled]="true">{{'aggregatedpage.Select HalfYearly' | translate}}</option>
                <option *ngFor="let item of halfyearlyList |keyvalue" value="{{item['key']}}">
                  {{'aggregatedpage.' +item['value'] | translate}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-xl col-md-6">
            <div class="form-group">
              <label>{{'header.state' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="selectedstate" class="form-control custom-selectbox"
                (change)="showdistrictdropdown(selectedstate)">
                <option value="ALL">{{'dataSubs.ALL STATES' | translate}}</option>
                <option *ngFor="let state of statelists" value="{{state.uuid}}">
                  {{'tabledataforstates.'+ state['name'] | translate}}</option>
              </select>
            </div>
          </div>
          <!-- <div class="form-group " *ngIf="showdistdrop">
              <label style="margin-left: 20px;" >{{'header.district' | translate }}<span class="required-field">*</span></label>
              <select style="width: 200px; margin-left: 20px;" [(ngModel)]="selecteddistrict"
                class="form-control custom-selectbox">
                <option value="undefined">{{'tabledataforstates.all' | translate}}</option>
                <option *ngFor="let district of distrctentityList" value="{{district['uuid']}}">{{ 'districtsdata.' + district['name'] | translate}}</option>
              </select>
               <span style="color:red" [hidden]="validation['district']">{{'viewreprt.validation1' | translate}}</span> -->
          <!-- </div> -->
          <div class="col d-flex align-items-end justify-content-end">
            <div class="form-group">
              <label></label>
              <button class="btn btn-info pointer" (click)="getTableData()"
                type="submit">{{'dataSubs.VIEW' | translate}}</button>
            </div>
          </div>
          <div class="col-auto d-flex justify-content-end align-items-end" *ngIf="showprintData">
            <div class="form-group">
              <label></label>
              <button class="btn btn-info pointer" (click)="printTableData()" type="submit">{{ 'listofdgc.print' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm" *ngIf="showTableData">
          <cdk-virtual-scroll-viewport #scrollViewport itemSize="" style="height: 500px">
            <div *ngIf="showTableData && selectedQuat == 'q1' && dynamicTimePeriod == 'quarterly'">
              <table class="table text-center table-sm mt-1" id="content">
                <thead class="thead-light">
                  <tr>
                    <th rowspan="3" style="text-align: center;">{{'dataSubs.sno' | translate}}</th>
                    <th *ngIf="selectedstate=='ALL'" rowspan="3" style="text-align: center;">
                      {{'header.state' | translate}}</th>
                    <th rowspan="3" style="text-align: center;">{{'header.Districts' | translate}}</th>
                    <th *ngIf="selectedQuat == 'q1'" colspan="6" style="text-align: center;">
                      {{'aggregatedpage.Quarter' | translate}} 1</th>
                  </tr>
                  <tr>
                    <th colspan="3" style="background-color:rgb(201 216 217)">
                      {{'dataSubs.Meeting Status based on attendance' | translate}}</th>
                    <th colspan="3" style="background-color:rgb(175 177 178)">
                      {{'dataSubs.Meeting Minutes Document Status' | translate}}</th>
                  </tr>
                  <tr>
                    <th>{{'monthmaps.April'|translate}}</th>
                    <th>{{'monthmaps.May'|translate}}</th>
                    <th>{{'monthmaps.June'|translate}}</th>
                    <th>{{'monthmaps.April'|translate}}</th>
                    <th>{{'monthmaps.May'|translate}}</th>
                    <th>{{'monthmaps.June'|translate}}</th>
                  </tr>
                </thead>
  
                <tbody class="text-white">
                  <ng-container *ngFor="let state of fullData| keyvalue;let k=index">
                    <ng-container *ngIf="k==0">{{initialize_count()}}</ng-container>
                    <tr *ngFor="let dist of state.value |keyvalue ;let i=index">
                      <!-- <td>{{i+1}}</td> -->
                      <td>{{i+1?increment():count}}</td>
                      <td *ngIf="selectedstate=='ALL'">{{'tabledataforstates.' +state.key | translate}}</td>
                      <td>{{'districtsdata.' +dist.key | translate}}</td>
                      <td style="background-color:aliceblue"
                        *ngFor="let element of dist.value['meetingDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                      <td style="background-color:#e7e3ee;"
                        *ngFor="let element of dist.value['minutesDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div *ngIf="showTableData && selectedQuat == 'q2' && dynamicTimePeriod == 'quarterly'">
              <table class="table text-center table-sm mt-1" id="content">
                <thead class="thead-light">
                  <tr>
                    <th rowspan="3" style="text-align: center;">{{'dataSubs.sno' | translate}}</th>
                    <th *ngIf="selectedstate=='ALL'" rowspan="3" style="text-align: center;">
                      {{'header.state' | translate}}</th>
                    <th rowspan="3" style="text-align: center;">{{'header.Districts' | translate}}</th>
                    <th *ngIf="selectedQuat == 'q2'" colspan="6" style="text-align: center;">
                      {{'aggregatedpage.Quarter' | translate}} 2</th>
                  </tr>
                  <tr>
                    <th colspan="3" style="background-color:rgb(201 216 217)">
                      {{'dataSubs.Meeting Status based on attendance' | translate}}</th>
                    <th colspan="3" style="background-color:rgb(175 177 178)">
                      {{'dataSubs.Meeting Minutes Document Status' | translate}}</th>
                  </tr>
                  <tr>
                    <th>{{'monthmaps.July'|translate}}</th>
                    <th>{{'monthmaps.August'|translate}}</th>
                    <th>{{'monthmaps.September'|translate}}</th>
                    <th>{{'monthmaps.July'|translate}}</th>
                    <th>{{'monthmaps.August'|translate}}</th>
                    <th>{{'monthmaps.September'|translate}}</th>
                  </tr>
                </thead>
                <tbody class="text-white">
                  <ng-container *ngFor="let state of fullData| keyvalue;let k=index">
                    <ng-container *ngIf="k==0">{{initialize_count()}}</ng-container>
                    <tr *ngFor="let dist of state.value |keyvalue ;let i=index">
                      <!-- <td>{{i+1}}</td> -->
                      <td>{{i+1?increment():count}}</td>
                      <td *ngIf="selectedstate=='ALL'">{{'tabledataforstates.' +state.key | translate}}</td>
                      <td>{{'districtsdata.' +dist.key | translate}}</td>
                      <td style="background-color:aliceblue"
                        *ngFor="let element of dist.value['meetingDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                      <td style="background-color:#e7e3ee;"
                        *ngFor="let element of dist.value['minutesDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm"
              *ngIf="showTableData && selectedQuat == 'q3' && dynamicTimePeriod == 'quarterly'">
              <table class="table text-center table-sm mt-1" id="content">
                <thead class="thead-light">
                  <tr>
                    <th rowspan="3" style="text-align: center;">{{'dataSubs.sno' | translate}}</th>
                    <th *ngIf="selectedstate=='ALL'" rowspan="3" style="text-align: center;">
                      {{'header.state' | translate}}</th>
                    <th rowspan="3" style="text-align: center;">{{'header.Districts' | translate}}</th>
                    <th *ngIf="selectedQuat == 'q3'" colspan="6" style="text-align: center;">
                      {{'aggregatedpage.Quarter' | translate}} 3</th>
                  </tr>
                  <tr>
                    <th colspan="3" style="background-color:rgb(201 216 217)">
                      {{'dataSubs.Meeting Status based on attendance' | translate}}</th>
                    <th colspan="3" style="background-color:rgb(175 177 178)">
                      {{'dataSubs.Meeting Minutes Document Status' | translate}}</th>
                  </tr>
                  <tr>
                    <th>{{'monthmaps.October'|translate}}</th>
                    <th>{{'monthmaps.November'|translate}}</th>
                    <th>{{'monthmaps.December'|translate}}</th>
                    <th>{{'monthmaps.October'|translate}}</th>
                    <th>{{'monthmaps.November'|translate}}</th>
                    <th>{{'monthmaps.December'|translate}}</th>
                  </tr>
                </thead>
                <tbody class="text-white">
                  <ng-container *ngFor="let state of fullData| keyvalue; let k=index">
                    <ng-container *ngIf="k==0">{{initialize_count()}}</ng-container>
                    <tr *ngFor="let dist of state.value |keyvalue ;let i=index">
                      <!-- <td>{{i+1}}</td> -->
                      <td>{{i+1?increment():count}}</td>
                      <td *ngIf="selectedstate=='ALL'">{{'tabledataforstates.' +state.key | translate}}</td>
                      <td>{{'districtsdata.' +dist.key | translate}}</td>
                      <td style="background-color:aliceblue"
                        *ngFor="let element of dist.value['meetingDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                      <td style="background-color:#e7e3ee;"
                        *ngFor="let element of dist.value['minutesDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div *ngIf="showTableData && selectedQuat == 'q4' && dynamicTimePeriod == 'quarterly'">
              <table class="table text-center table-sm mt-1" id="content">
                <thead class="thead-light">
                  <tr>
                    <th rowspan="3" style="text-align: center;">{{'dataSubs.sno' | translate}}</th>
                    <th *ngIf="selectedstate=='ALL'" rowspan="3" style="text-align: center;">
                      {{'header.state' | translate}}</th>
                    <th rowspan="3" style="text-align: center;">{{'header.Districts' | translate}}</th>
                    <th *ngIf="selectedQuat == 'q4'" colspan="6" style="text-align: center;">
                      {{'aggregatedpage.Quarter' | translate}} 4</th>
                  </tr>
                  <tr>
                    <th colspan="3" style="background-color:rgb(201 216 217)">
                      {{'dataSubs.Meeting Status based on attendance' | translate}}</th>
                    <th colspan="3" style="background-color:rgb(175 177 178)">
                      {{'dataSubs.Meeting Minutes Document Status' | translate}}</th>
                  </tr>
                  <tr>
                    <th>{{'monthmaps.January'|translate}}</th>
                    <th>{{'monthmaps.February'|translate}}</th>
                    <th>{{'monthmaps.March'|translate}}</th>
                    <th>{{'monthmaps.January'|translate}}</th>
                    <th>{{'monthmaps.February'|translate}}</th>
                    <th>{{'monthmaps.March'|translate}}</th>
                  </tr>
                </thead>
                <tbody class="text-white">
                  <ng-container *ngFor="let state of fullData| keyvalue; let k=index">
                    <ng-container *ngIf="k==0">{{initialize_count()}}</ng-container>
                    <tr *ngFor="let dist of state.value |keyvalue ;let i=index">
                      <td>{{i+1?increment():count}}</td>
                      <td *ngIf="selectedstate=='ALL'">{{'tabledataforstates.' +state.key | translate}}</td>
                      <td>{{'districtsdata.' +dist.key | translate}}</td>
                      <td style="background-color:aliceblue"
                        *ngFor="let element of dist.value['meetingDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                      <td style="background-color:#e7e3ee;"
                        *ngFor="let element of dist.value['minutesDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div *ngIf="showTableData && dynamicTimePeriod == 'monthly'">
              <table class="table text-center table-sm mt-1" id="content">
                <thead class="thead-light">
                  <tr>
                    <th rowspan="3" style="text-align: center;">{{'dataSubs.sno' | translate}}</th>
                    <th *ngIf="selectedstate=='ALL'" rowspan="3" style="text-align: center;">
                      {{'header.state' | translate}}</th>
                    <th rowspan="3" style="text-align: center;">{{'header.Districts' | translate}}</th>
                    <th style="background-color:rgb(201 216 217)">
                      {{'dataSubs.Meeting Status based on attendance' | translate}}</th>
                    <!-- <div class="vl"></div> style="background-color:bisque"-->
                    <!-- <th class="vl"></th> style="background-color:azure"-->
                    <th class="vl" style="background-color:rgb(175 177 178)">
                      {{'dataSubs.Meeting Minutes Document Status' | translate}}</th>
                  </tr>
                </thead>
                <tbody class="text-white">
                  <ng-container *ngFor="let state of fullData| keyvalue; let k=index">
                    <ng-container *ngIf="k==0">{{initialize_count()}}</ng-container>
                    <tr *ngFor="let dist of state.value |keyvalue;let i=index">
                      <!-- <tr *ngFor="let dist of state.value |keyvalue ;let i=index">-->
                      <!-- <td>{{i+1}}</td> -->
                      <td>{{i+1?increment():count}}</td>
                      <td *ngIf="selectedstate=='ALL'">{{'tabledataforstates.' +state.key | translate}}</td>
                      <td>{{'districtsdata.' +dist.key | translate}}</td>
                      <td style="background-color:aliceblue"
                        *ngFor="let element of dist.value['meetingDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                      <!-- <div class="vl"></div> -->
                      <!-- <td class="vl"> </td> -->
                      <td style="background-color:#e7e3ee;"
                        *ngFor="let element of dist.value['minutesDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div *ngIf="showTableData && selectedhalfyear == 'h1' && dynamicTimePeriod == 'halfyearly'">
              <table class="table text-center table-sm mt-1" id="content">
                <thead class="thead-light">
                  <tr>
                    <th rowspan="3" style="text-align: center;">{{'dataSubs.sno' | translate}}</th>
                    <th *ngIf="selectedstate=='ALL'" rowspan="3" style="text-align: center;">
                      {{'header.state' | translate}}</th>
                    <th rowspan="3" style="text-align: center;">{{'header.Districts' | translate}}</th>
                    <th *ngIf="selectedhalfyear == 'h1'" colspan="12" style="text-align: center;">
                      1<sup>{{'aggregatedpage.st' | translate}}</sup>{{'aggregatedpage.Half Year' | translate}}</th>
                    <!-- <th *ngIf="selectedhalfyear == 'h2'" colspan="12" style="text-align: center;">2<sup>nd</sup>Half Year</th> -->
                  </tr>
                  <tr>
                    <th colspan="6" style="background-color:rgb(201 216 217)">
                      {{'dataSubs.Meeting Status based on attendance' | translate}}</th>
                    <th colspan="6" style="background-color:rgb(175 177 178)">
                      {{'dataSubs.Meeting Minutes Document Status' | translate}}</th>
                  </tr>
                  <tr>
                    <th>{{'monthmaps.April'|translate}}</th>
                    <th>{{'monthmaps.May'|translate}}</th>
                    <th>{{'monthmaps.June'|translate}}</th>
                    <th>{{'monthmaps.July'|translate}}</th>
                    <th>{{'monthmaps.August'|translate}}</th>
                    <th>{{'monthmaps.September'|translate}}</th>
                    <th>{{'monthmaps.April'|translate}}</th>
                    <th>{{'monthmaps.May'|translate}}</th>
                    <th>{{'monthmaps.June'|translate}}</th>
                    <th>{{'monthmaps.July'|translate}}</th>
                    <th>{{'monthmaps.August'|translate}}</th>
                    <th>{{'monthmaps.September'|translate}}</th>
                    <!-- <th *ngIf="selectedhalfyear == 'h2'">October</th>
                <th *ngIf="selectedhalfyear == 'h2'">November</th>
                <th *ngIf="selectedhalfyear == 'h2'">December</th>
                <th *ngIf="selectedhalfyear == 'h2'">January</th>
                <th *ngIf="selectedhalfyear == 'h2'">February</th>
                <th *ngIf="selectedhalfyear == 'h2'">March</th>
                <th *ngIf="selectedhalfyear == 'h2'">October</th>
                <th *ngIf="selectedhalfyear == 'h2'">November</th>
                <th *ngIf="selectedhalfyear == 'h2'">December</th>
                <th *ngIf="selectedhalfyear == 'h2'">January</th>
                <th *ngIf="selectedhalfyear == 'h2'">February</th>
                <th *ngIf="selectedhalfyear == 'h2'">March</th> -->
                  </tr>
                </thead>
                <tbody class="text-white">
                  <ng-container *ngFor="let state of fullData| keyvalue; let k=index">
                    <ng-container *ngIf="k==0">{{initialize_count()}}</ng-container>
                    <tr *ngFor="let dist of state.value |keyvalue ;let i=index">
                      <!-- <td>{{i+1}}</td> -->
                      <td>{{i+1?increment():count}}</td>
                      <td *ngIf="selectedstate=='ALL'">{{'tabledataforstates.' +state.key | translate}}</td>
                      <td>{{'districtsdata.' +dist.key | translate}}</td>
                      <td style="background-color:aliceblue"
                        *ngFor="let element of dist.value['meetingDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                      <td style="background-color:#e7e3ee;"
                        *ngFor="let element of dist.value['minutesDelayed'] |keyvalue">{{ 'meetingreport.' + element.value | translate }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div *ngIf="showTableData && selectedhalfyear == 'h2' && dynamicTimePeriod == 'halfyearly'">
              <table class="table text-center table-sm mt-1" id="content">
                <thead class="thead-light">
                  <tr>
                    <th rowspan="3" style="text-align: center;">{{'dataSubs.sno' | translate}}</th>
                    <th *ngIf="selectedstate=='ALL'" rowspan="3" style="text-align: center;">
                      {{'header.state' | translate}}</th>
                    <th rowspan="3" style="text-align: center;">{{'header.Districts' | translate}}</th>
                    <!-- <th *ngIf="selectedhalfyear == 'h2'" colspan="12" style="text-align: center;">1<sup>st</sup>Half Year</th> -->
                    <th *ngIf="selectedhalfyear == 'h2'" colspan="12" style="text-align: center;">
                      2<sup>{{'aggregatedpage.nd' | translate}}</sup>{{'aggregatedpage.Half Year' | translate}}</th>
                  </tr>
                  <tr>
                    <th colspan="6" style="background-color:rgb(201 216 217)">
                      {{'dataSubs.Meeting Status based on attendance' | translate}}</th>
                    <th colspan="6" style="background-color:rgb(175 177 178)">
                      {{'dataSubs.Meeting Minutes Document Status' | translate}}</th>
                  </tr>
                  <tr>
                    <th>{{'monthmaps.October'|translate}}</th>
                    <th>{{'monthmaps.November'|translate}}</th>
                    <th>{{'monthmaps.December'|translate}}</th>
                    <th>{{'monthmaps.January'|translate}}</th>
                    <th>{{'monthmaps.February'|translate}}</th>
                    <th>{{'monthmaps.March'|translate}}</th>
                    <th>{{'monthmaps.October'|translate}}</th>
                    <th>{{'monthmaps.November'|translate}}</th>
                    <th>{{'monthmaps.December'|translate}}</th>
                    <th>{{'monthmaps.January'|translate}}</th>
                    <th>{{'monthmaps.February'|translate}}</th>
                    <th>{{'monthmaps.March'|translate}}</th>
                  </tr>
                </thead>
                <tbody class="text-white">
                  <ng-container *ngFor="let state of fullData| keyvalue; let k=index">
                    <ng-container *ngIf="k==0">{{initialize_count()}}</ng-container>
                    <tr *ngFor="let dist of state.value |keyvalue ;let i=index">
                      <!-- <td>{{i+1}}</td> -->
                      <td>{{i+1?increment():count}}</td>
                      <td *ngIf="selectedstate=='ALL'">{{'tabledataforstates.' +state.key | translate}}</td>
                      <td>{{'districtsdata.' +dist.key | translate}}</td>
                      <!-- <td style="background-color:aliceblue" *ngFor = "let element of dist.value['meetingDelayed'] |keyvalue">{{element.value}}</td> -->
                      <td style="background-color:aliceblue" *ngFor="let element of sequence">
                        {{dist.value['meetingDelayed'][element]}}</td>
                      <!-- <td style="background-color:#e7e3ee;" *ngFor = "let element of dist.value['minutesDelayed'] |keyvalue">{{element.value }}</td> -->
                      <td style="background-color:#e7e3ee;" *ngFor="let element of sequence">
                        {{dist.value['minutesDelayed'][element] }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div *ngIf="showTableData && dynamicTimePeriod == 'annually'" id="content">
              <table class="table text-center table-sm mt-1">
                <thead class="thead-light">
                  <tr>
                    <th rowspan="3" style="text-align: center;">{{'dataSubs.sno' | translate}}</th>
                    <th *ngIf="selectedstate=='ALL'" rowspan="3" style="text-align: center;">
                      {{'header.state' | translate}}</th>
                    <th rowspan="3" style="text-align: center;">{{'header.Districts' | translate}}</th>
                    <th colspan="24">{{'aggregatedpage.Annual Year' | translate}}{{editweightfilter['ay']}}
                      {{'dataSubs.status'|translate}}</th>
                  </tr>
                  <tr>
                    <th colspan="12" style="background-color:rgb(201 216 217)">
                      {{'dataSubs.Meeting Status based on attendance' | translate}}</th>
                    <th colspan="12" style="background-color:rgb(175 177 178)">
                      {{'dataSubs.Meeting Minutes Document Status' | translate}}</th>
                  </tr>
                  <tr>
                    <th *ngFor="let month of monthListArray">{{'monthmaps.' +month|translate}}</th>
                    <th *ngFor="let month of monthListArray">{{'monthmaps.' +month|translate}}</th>
                  </tr>
                </thead>
                <tbody class="text-white">
                  <ng-container *ngFor="let districtData of formattedData;let i=index">
                    <tr>
                      <td>{{i+1}}</td>
                      <td *ngIf="selectedstate=='ALL'">{{ 'tabledataforstates.' + districtData['stateName'] | translate }}</td>
                      <td>{{ 'districtsdata.' + districtData['distName'] | translate }}</td>
                      <td style="background-color:aliceblue" *ngFor="let item of districtData['meetingDelayed']">{{ 'meetingreport.' + item | translate }}
                      </td>
                      <td style="background-color:#e7e3ee;" *ngFor="let item of districtData['uploadedMinutes']">{{ 'meetingreport.' + item | translate }}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </div>
  </div>
</div>